import type { CreateDistributorBody } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useCreateDistributor() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: CreateDistributorBody) =>
      post({
        url: `/distributors`,
        body: { ...params },
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getDistributors }),
  });

  const createDistributor = useCallback(
    (params: CreateDistributorBody) => mutate(params),
    [mutate]
  );

  return {
    createDistributor,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
